/*
 * @Author: Jason
 * @Date: 2025-06-27 15:40:41
 * @LastEditors: Jason
 * @LastEditTime: 2025-08-08 17:58:00
 * @FilePath: /MSFinWeb/src/constants.js
 * @Description:
 *
 * Copyright (c) 2025 by ${git_name_email}, All Rights Reserved.
 */
// 使用全局的 ConfigManager
import ccm from '../public/ccm'
const ConfigManager = window.ConfigManager

const config = ConfigManager.getConfig()

if (!config) {
  setTimeout(() => {
    location.reload()
  }, 300)
}
// 提供默认值，避免配置未加载时的错误
export const API_IP =
  process.env.NODE_ENV === 'development'
    ? ((config && config.url) ? config.url : 'localhost')
    : (window.location.hostname || 'localhost')
export const API_PORT =
  process.env.NODE_ENV === 'development'
    ? '37494'
    : config
      ? window.location.protocol === 'https:'
        ? config.httpsPort
        : config.port
      : '37494'

export const API_URL = ConfigManager.getApiUrl() || 'http://localhost:37494'

export const SUPPORT_MAPS = [
  { name: 'google_street', value: 'google_street', text: '谷歌地图', selected: false },
  { name: 'google_highbird', value: 'google_highbird', text: '谷歌鸟瞰图', selected: false },
  { name: 'open_street', value: 'open_street', text: 'open地图', selected: false },
  { name: 'google_satellite', value: 'google_satellite', text: '谷歌卫星', selected: false },
  { name: 'tiandi_street', value: 'tiandi_street', text: '天地图', selected: false },
  { name: 'tiandi_satellite', value: 'tiandi_satellite', text: '天地图卫星', selected: false },
]
